/* eslint-disable class-methods-use-this */

/* eslint-disable id-length */
/* eslint-disable sort-keys */
/* eslint-disable consistent-return */
/* eslint-disable id-match */
/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable strict */
class SwiperSlider extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      swiper: 'swiper-container',
      prevEl: '.custom-prev-button',
      nextEl: '.custom-next-button',
      scrollbar: '.custom-scrollbar',
    };

    // Add properties for video control
    this.thumbVideosAutoplay = new Set(); // Store videos that should autoplay
    this.videoControlsInitialized = false;
    this.isVideoProtected = false; // Protection from external scripts
    this.debugMode = false; // Enable detailed logging (set false for production)
  }

  connectedCallback() {
    this.slider = this.querySelector(this.selectors.swiper);
    this.buttonPrev = this.querySelector(this.selectors.prevEl);
    this.buttonNext = this.querySelector(this.selectors.nextEl);
    this.scrollbar = this.querySelector(this.selectors.scrollbar);
    this.options = this.slider?.getAttribute('data-options');

    console.log('SwiperSlider connected:', {
      slider: this.slider,
      isPDPGallery: this.isPDPGallery(),
      element: this,
    });

    if (!this.slider) {
      return null;
    }
    this.initSlider();
    this.addListeners();
    this.initVideoControls();
  }

  getSwiperConfig(inlineOptions) {
    return {
      slidesPerView: 4,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      watchSlidesProgress: true,
      spaceBetween: 34,
      breakpoints: {
        480: {
          slidesPerView: '2',
          spaceBetween: 15,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev,
      },
      scrollbar: {
        el: this.scrollbar,
        draggable: true,
        hide: false,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      ...inlineOptions,
    };
  }

  initSlider() {
    let inlineOptions = this.slider.dataset.options;

    if (inlineOptions) {
      inlineOptions = JSON.parse(inlineOptions);
    }

    this.swiperParams = this.getSwiperConfig(inlineOptions);
    Object.assign(this.slider, this.swiperParams);
    this.slider.initialize();

    console.log(`slider`, this.swiperParams);

    // Add event handlers for Swiper Element
    this.setupSwiperEventListeners();
  }

  handleSlideChange(slideIndex) {
    // Check if this is PDP gallery
    if (!this.isPDPGallery()) return;

    // First pause all videos
    this.pauseAllVideos();
    console.log(`slideIndex`, slideIndex);
    // Then play video on active slide
    this.playActiveSlideVideo();
  }

  handleThumbSlideChange(slideIndex) {
    // Check if this is Thumb gallery
    if (!this.isMainPDPGalleryThumb()) return;

    console.log(`Thumb slide changed to: ${slideIndex}`);

    // For Thumb gallery automatically play all visible videos
    // but stop videos that went out of visibility
    this.updateThumbVideoPlayback();
  }

  updateThumbVideoPlayback() {
    if (!this.isMainPDPGalleryThumb()) return;

    const visibleSlides = this.getVisibleSlides();
    const allSlides = Array.from(this.slider.querySelectorAll('swiper-slide'));

    // Stop videos in all slides
    allSlides.forEach((slide) => {
      const videoElement = slide.querySelector('video-media');
      if (videoElement) {
        // If slide is not visible, stop video and remove from autoplay list
        if (!visibleSlides.includes(slide)) {
          this.thumbVideosAutoplay.delete(videoElement);
          this.pauseVideo(videoElement);
        }
      }
    });

    // Play videos in visible slides
    visibleSlides.forEach((slide) => {
      const mediaElement = slide.querySelector('.product-gallery__media');
      if (!mediaElement) return;

      const mediaType = mediaElement.getAttribute('data-media-type');
      if (mediaType !== 'video' && mediaType !== 'external_video') return;

      const videoElement = slide.querySelector('video-media');
      if (videoElement) {
        // Add to autoplay list and play
        this.thumbVideosAutoplay.add(videoElement);
        this.playVideo(videoElement);
      }
    });
  }

  pauseAllVideos() {
    // Work only with required sliders
    if (!this.isPDPGallery() && !this.isMainPDPGalleryThumb()) return;

    // Find all video elements only in visible slides
    const visibleSlides = this.getVisibleSlides();
    const allVideoElements = [];

    visibleSlides.forEach((slide) => {
      const videoElement = slide.querySelector('video-media');
      if (videoElement) {
        allVideoElements.push(videoElement);
      }
    });

    console.log(`Pausing ${allVideoElements.length} videos in visible slides`);
    allVideoElements.forEach((videoElement) => {
      this.pauseVideo(videoElement);
    });
  }

  setupSwiperEventListeners() {
    if (!this.slider) return;

    // For Swiper Element use addEventListener
    this.slider.addEventListener('swiperinit', () => {
      console.log('Swiper initialized');

      // Initialize video controls after Swiper initialization
      setTimeout(() => {
        this.initVideoControls();
      }, 50);

      if (this.isPDPGallery()) {
        const INIT_DELAY = 100;
        setTimeout(() => {
          this.playActiveSlideVideo();
        }, INIT_DELAY);
      } else if (this.isMainPDPGalleryThumb()) {
        console.log('PDP Thumb gallery initialized, setting up autoplay');
        const INIT_DELAY = 100;
        setTimeout(() => {
          this.setupThumbVideoAutoplay();
        }, INIT_DELAY);
      }
    });

    this.slider.addEventListener('swiperslidechange', (event) => {
      const SWIPER_INSTANCE_INDEX = 0;
      const swiperInstance = event.detail[SWIPER_INSTANCE_INDEX];
      console.log('Slide changed to:', swiperInstance.activeIndex);
      if (this.isPDPGallery()) {
        this.handleSlideChange(swiperInstance.activeIndex);
      } else if (this.isMainPDPGalleryThumb()) {
        this.handleThumbSlideChange(swiperInstance.activeIndex);
      }
    });

    // If Swiper is already initialized
    if (this.slider.swiper) {
      console.log('Swiper already initialized');

      // Initialize video controls
      setTimeout(() => {
        this.initVideoControls();
      }, 50);

      if (this.isPDPGallery()) {
        this.playActiveSlideVideo();
      } else if (this.isMainPDPGalleryThumb()) {
        this.setupThumbVideoAutoplay();
      }
    }
  }

  isPDPGallery() {
    // Check if this is PDP gallery with video control
    return (
      this.slider &&
      this.slider.closest('.product-gallery__container') &&
      this.slider.classList.contains('swiper-container-big-gallery')
    );
  }

  isMainPDPGalleryThumb() {
    return (
      this.slider &&
      this.slider.closest('.product-gallery__container') &&
      this.slider.classList.contains('swiper-thumb')
    );
  }

  getFilteredIndexes() {
    // Get filtered-indexes from product-gallery element
    // IMPORTANT: filtered-indexes contains indexes of HIDDEN slides, not visible ones!
    const productGallery = this.slider.closest('product-gallery');
    if (!productGallery) return [];

    const filteredIndexesAttr = productGallery.getAttribute('filtered-indexes');
    if (!filteredIndexesAttr) return [];

    try {
      // Parse JSON and convert to 0-based indexes (Shopify uses 1-based)
      const RADIX = 10;
      const SHOPIFY_INDEX_OFFSET = 1;
      return JSON.parse(filteredIndexesAttr).map((index) => parseInt(index, RADIX) - SHOPIFY_INDEX_OFFSET);
    } catch (error) {
      console.warn('Error parsing filtered-indexes:', error);
      return [];
    }
  }

  getVisibleSlides() {
    if (!this.slider) return [];

    const allSlides = Array.from(this.slider.querySelectorAll('swiper-slide'));
    const hiddenIndexes = this.getFilteredIndexes(); // These are indexes of HIDDEN slides

    // Filter slides, excluding those in filtered-indexes (hidden)
    return allSlides.filter((slide, index) => !hiddenIndexes.includes(index));
  }

  getVisibleSlideIndexFromSwiperIndex(swiperActiveIndex) {
    // Convert Swiper activeIndex to real visible slide index
    const allSlides = Array.from(this.slider.querySelectorAll('swiper-slide'));
    const hiddenIndexes = this.getFilteredIndexes();

    let visibleSlideCount = 0;
    let targetSlideIndex = -1;

    for (let i = 0; i < allSlides.length; i++) {
      // If slide is not hidden
      if (!hiddenIndexes.includes(i)) {
        // If this is our target visible slide
        if (visibleSlideCount === swiperActiveIndex) {
          targetSlideIndex = i;
          break;
        }
        visibleSlideCount++;
      }
    }

    console.log(`Converting swiper index ${swiperActiveIndex} to slide index ${targetSlideIndex}`);
    return targetSlideIndex;
  }

  getActiveVisibleSlide() {
    if (!this.slider || !this.slider.swiper) return null;

    const allSlides = Array.from(this.slider.querySelectorAll('swiper-slide'));
    const visibleSlides = this.getVisibleSlides();
    const hiddenIndexes = this.getFilteredIndexes();
    const swiperActiveIndex = this.slider.swiper.activeIndex;

    console.log(`Slide analysis:`, {
      total: allSlides.length,
      visible: visibleSlides.length,
      hidden: hiddenIndexes.length,
      hiddenIndexes: hiddenIndexes,
      swiperActiveIndex: swiperActiveIndex,
    });

    // Convert Swiper activeIndex to real slide index
    const realSlideIndex = this.getVisibleSlideIndexFromSwiperIndex(swiperActiveIndex);

    const MIN_INDEX = 0;
    if (realSlideIndex >= MIN_INDEX && realSlideIndex < allSlides.length) {
      const targetSlide = allSlides[realSlideIndex];

      // Check if this slide is really visible (not hidden)
      if (!hiddenIndexes.includes(realSlideIndex)) {
        console.log(`Found active slide at real index ${realSlideIndex}`);
        return targetSlide;
      }
    }

    // Fallback: try to find slide with swiper-slide-active class among visible ones
    const activeSlideByClass = visibleSlides.find((slide) => slide.classList.contains('swiper-slide-active'));

    if (activeSlideByClass) {
      console.log('Found active slide by class (fallback)');
      return activeSlideByClass;
    }

    // Last fallback: take first visible slide
    const FIRST_SLIDE_INDEX = 0;
    if (visibleSlides.length > FIRST_SLIDE_INDEX) {
      console.log('Fallback to first visible slide');
      return visibleSlides[FIRST_SLIDE_INDEX];
    }

    console.log('No visible slides found');
    return null;
  }

  setupThumbVideoAutoplay() {
    if (!this.slider) return;
    if (!this.isMainPDPGalleryThumb()) return;

    this.log('Setting up autoplay for thumb gallery videos');

    // Enable video protection
    this.enableVideoProtection();

    // Find only visible slides in thumbnail gallery
    const visibleSlides = this.getVisibleSlides();
    const hiddenIndexes = this.getFilteredIndexes();

    this.log(`Thumb gallery: ${visibleSlides.length} visible slides, ${hiddenIndexes.length} hidden slides`);

    visibleSlides.forEach((slide, visibleIndex) => {
      const mediaElement = slide.querySelector('.product-gallery__media');
      if (!mediaElement) return;

      const mediaType = mediaElement.getAttribute('data-media-type');
      if (mediaType !== 'video' && mediaType !== 'external_video') return;

      const videoElement = slide.querySelector('video-media');
      if (videoElement) {
        this.log(`Setting up autoplay for visible thumb video at index ${visibleIndex}`);

        // Add video to autoplay list
        this.thumbVideosAutoplay.add(videoElement);

        // Protect this video
        this.protectVideoElement(videoElement);

        // Add small delay for each video
        const BASE_AUTOPLAY_DELAY = 200;
        const DELAY_INCREMENT = 100;
        const AUTOPLAY_DELAY = BASE_AUTOPLAY_DELAY + visibleIndex * DELAY_INCREMENT;
        setTimeout(() => {
          this.playVideo(videoElement);
          this.updateVideoButtonsForSlide(slide, videoElement);
        }, AUTOPLAY_DELAY);
      }
    });

    // Start monitoring to maintain autoplay only if not already started
    if (!this.thumbVideoMonitorInterval) {
      this.startThumbVideoMonitoring();
    }
  }

  startThumbVideoMonitoring() {
    if (!this.isMainPDPGalleryThumb()) return;

    // Clear previous interval if exists
    if (this.thumbVideoMonitorInterval) {
      clearInterval(this.thumbVideoMonitorInterval);
      this.thumbVideoMonitorInterval = null;
    }

    // Start monitoring every 3 seconds (increased interval)
    const MONITOR_INTERVAL = 3000;
    this.thumbVideoMonitorInterval = setInterval(() => {
      this.maintainThumbVideoAutoplay();
    }, MONITOR_INTERVAL);

    this.log('Started thumb video monitoring with interval:', MONITOR_INTERVAL);
  }

  maintainThumbVideoAutoplay() {
    if (!this.isMainPDPGalleryThumb()) return;

    let restartedCount = 0;

    // Check all videos that should autoplay
    this.thumbVideosAutoplay.forEach((videoElement) => {
      if (!this.isVideoPlaying(videoElement)) {
        this.log('Restarting paused thumb video');
        this.forcePlayVideo(videoElement);
        restartedCount++;

        // Update buttons
        const slide = videoElement.closest('swiper-slide');
        if (slide) {
          this.updateVideoButtonsForSlide(slide, videoElement);
        }
      }
    });

    // Log only if something was restarted
    if (restartedCount > 0) {
      this.log(`Restarted ${restartedCount} thumb videos`);
    }
  }

  forcePlayVideo(videoElement) {
    if (!videoElement) return;

    this.log('Force playing video:', videoElement);

    try {
      const nativeVideo = videoElement.querySelector('video');
      if (nativeVideo) {
        // Use original play method if available
        if (this.originalPauseMethods && this.originalPauseMethods.has(nativeVideo)) {
          // Temporarily restore original method
          const originalPause = this.originalPauseMethods.get(nativeVideo);
          nativeVideo.pause = originalPause;

          // Play video
          if (nativeVideo.paused) {
            nativeVideo.play().catch((error) => {
              this.log('Error force playing native video:', error);
            });
          }

          // Set protection again
          setTimeout(() => {
            this.protectVideoElement(videoElement);
          }, 100);
        } else {
          if (nativeVideo.paused) {
            nativeVideo.play().catch((error) => {
              this.log('Error force playing native video:', error);
            });
          }
        }
      }

      // For external videos
      if (videoElement.hasAttribute('host')) {
        const host = videoElement.getAttribute('host');
        const iframe = videoElement.querySelector('iframe');

        if (iframe && iframe.contentWindow) {
          if (host === 'youtube') {
            iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            videoElement.classList.add('video-playing');
            videoElement.classList.remove('video-paused');
          } else if (host === 'vimeo') {
            iframe.contentWindow.postMessage('{"method":"play"}', '*');
            videoElement.classList.add('video-playing');
            videoElement.classList.remove('video-paused');
          }
        }
      }
    } catch (error) {
      this.log('Error force playing video:', error);
    }
  }

  updateVideoButtonsForSlide(slide, videoElement) {
    const videoActions = slide.querySelector('.product-gallery__video-actions');
    if (!videoActions) return;

    const playBtn = videoActions.querySelector('.product-gallery__video-play-icon');
    const pauseBtn = videoActions.querySelector('.product-gallery__video-pause-icon');

    this.updateVideoButtonsState(videoElement, playBtn, pauseBtn);
  }

  playActiveSlideVideo() {
    if (!this.slider || !this.slider.swiper) return;
    if (!this.isPDPGallery()) return;

    // First pause all other videos
    this.pauseAllNonActiveVideos();

    const activeSlide = this.getActiveVisibleSlide();
    if (!activeSlide) {
      console.log('No active visible slide found');
      return;
    }

    console.log(`activeSlide `, activeSlide);

    const mediaElement = activeSlide.querySelector('.product-gallery__media');
    if (!mediaElement) {
      console.log('No media element found in active slide');
      return;
    }

    const mediaType = mediaElement.getAttribute('data-media-type');
    console.log(`mediaType `, mediaType);
    if (mediaType !== 'video' && mediaType !== 'external_video') {
      console.log('Media is not video type');
      return;
    }

    const videoElement = activeSlide.querySelector('video-media');
    if (videoElement) {
      console.log('Playing video in active slide');
      const PLAY_DELAY = 300;
      setTimeout(() => {
        this.playVideo(videoElement);
        this.currentVideoElement = videoElement;
        this.updateVideoButtonsForSlide(activeSlide, videoElement);
      }, PLAY_DELAY);
    } else {
      console.log('No video element found in active slide');
    }
  }

  pauseAllNonActiveVideos() {
    if (!this.isPDPGallery()) return;

    const activeSlide = this.getActiveVisibleSlide();
    const allSlides = Array.from(this.slider.querySelectorAll('swiper-slide'));

    allSlides.forEach((slide) => {
      if (slide !== activeSlide) {
        const videoElement = slide.querySelector('video-media');
        if (videoElement) {
          this.pauseVideo(videoElement);
        }
      }
    });
  }

  pauseVideo(videoElement) {
    if (!videoElement) return;

    // Check if this video is protected from pause
    if (this.thumbVideosAutoplay.has(videoElement)) {
      this.log('Skipping pause for protected thumb video:', videoElement);
      return;
    }

    this.log('Pausing video:', videoElement);

    try {
      if (typeof videoElement.pause === 'function') {
        videoElement.pause();
        return;
      }

      const nativeVideo = videoElement.querySelector('video');
      if (nativeVideo && !nativeVideo.paused) {
        // Use original method if available
        if (this.originalPauseMethods && this.originalPauseMethods.has(nativeVideo)) {
          this.originalPauseMethods.get(nativeVideo).call(nativeVideo);
        } else {
          nativeVideo.pause();
        }
      }

      if (videoElement.hasAttribute('host') && videoElement.getAttribute('host') === 'youtube') {
        const iframe = videoElement.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
          this.log('Pausing YouTube video');
          iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          videoElement.classList.add('video-paused');
          videoElement.classList.remove('video-playing');
        }
      }

      if (videoElement.hasAttribute('host') && videoElement.getAttribute('host') === 'vimeo') {
        const iframe = videoElement.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
          this.log('Pausing Vimeo video');
          iframe.contentWindow.postMessage('{"method":"pause"}', '*');
          videoElement.classList.add('video-paused');
          videoElement.classList.remove('video-playing');
        }
      }

      // Update buttons after pause
      setTimeout(() => {
        const slide = videoElement.closest('swiper-slide');
        if (slide) {
          this.updateVideoButtonsForSlide(slide, videoElement);
        }
      }, 100);
    } catch (error) {
      this.log('Error pausing video:', error);
    }
  }

  playVideo(videoElement) {
    if (!videoElement) return;

    this.log('Playing video:', videoElement);

    try {
      if (typeof videoElement.play === 'function') {
        videoElement.play();
        return;
      }

      const nativeVideo = videoElement.querySelector('video');
      if (nativeVideo) {
        this.log('Playing native video, paused:', nativeVideo.paused);
        if (nativeVideo.paused) {
          nativeVideo.play().catch((error) => {
            this.log('Error playing native video:', error);
          });
        }
      }

      if (videoElement.hasAttribute('host') && videoElement.getAttribute('host') === 'youtube') {
        const iframe = videoElement.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
          this.log('Playing YouTube video');
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          videoElement.classList.add('video-playing');
          videoElement.classList.remove('video-paused');
        }
      }

      if (videoElement.hasAttribute('host') && videoElement.getAttribute('host') === 'vimeo') {
        const iframe = videoElement.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
          this.log('Playing Vimeo video');
          iframe.contentWindow.postMessage('{"method":"play"}', '*');
          videoElement.classList.add('video-playing');
          videoElement.classList.remove('video-paused');
        }
      }

      // Update buttons after playback
      setTimeout(() => {
        const slide = videoElement.closest('swiper-slide');
        if (slide) {
          this.updateVideoButtonsForSlide(slide, videoElement);
        }
      }, 100);
    } catch (error) {
      this.log('Error playing video:', error);
    }
  }

  addListeners() {
    document.addEventListener('shopify:section:reorder', () => this.initSlider());
    document.addEventListener('shopify:section:load', () => this.initSlider());
    document.addEventListener('shopify:section:select', () => this.initSlider());
    document.addEventListener('shopify:section:deselect', () => this.initSlider());
    document.addEventListener('changeSlide', (event) => {
      const { slideIndex } = event.detail;
      if (this.slider && this.slider.swiper) {
        this.slider.swiper.slideTo(slideIndex);

        this.handleSlideChange(slideIndex);
      }
    });

    // Listen for variant changes that can modify filtered-indexes
    document.addEventListener('variant:change', () => {
      if (this.isPDPGallery()) {
        console.log('Variant changed, updating video control');
        // Small delay to give time for DOM to update
        const UPDATE_DELAY = 100;
        setTimeout(() => {
          this.pauseAllVideos();
          this.playActiveSlideVideo();
        }, UPDATE_DELAY);
      } else if (this.isMainPDPGalleryThumb()) {
        console.log('Variant changed, updating thumb gallery autoplay');
        const UPDATE_DELAY = 100;
        setTimeout(() => {
          this.setupThumbVideoAutoplay();
        }, UPDATE_DELAY);
      }
    });
  }

  disconnectedCallback() {
    // Clear monitoring interval when component is disconnected
    if (this.thumbVideoMonitorInterval) {
      clearInterval(this.thumbVideoMonitorInterval);
      this.thumbVideoMonitorInterval = null;
    }

    // Clean up video controls
    this.cleanupVideoControls();

    // Clear autoplay list
    this.thumbVideosAutoplay.clear();

    // Disable video protection
    this.disableVideoProtection();

    this.log('SwiperSlider disconnected and cleaned up');
  }

  enableVideoProtection() {
    if (this.isVideoProtected) return;

    this.log('Enabling video protection from external scripts');

    // Intercept pause() calls for our videos
    this.originalPauseMethods = new Map();

    const allVideoElements = this.slider.querySelectorAll('video-media');
    allVideoElements.forEach((videoElement) => {
      this.protectVideoElement(videoElement);
    });

    this.isVideoProtected = true;
  }

  disableVideoProtection() {
    if (!this.isVideoProtected) return;

    this.log('Disabling video protection');

    // Restore original methods
    if (this.originalPauseMethods) {
      this.originalPauseMethods.forEach((originalMethod, videoElement) => {
        if (videoElement.pause && originalMethod) {
          videoElement.pause = originalMethod;
        }
      });
      this.originalPauseMethods.clear();
    }

    this.isVideoProtected = false;
  }

  protectVideoElement(videoElement) {
    if (!videoElement) return;

    const nativeVideo = videoElement.querySelector('video');
    if (nativeVideo && nativeVideo.pause) {
      this.originalPauseMethods.set(nativeVideo, nativeVideo.pause);

      // Intercept pause()
      nativeVideo.pause = () => {
        // Allow pause only if this is our call or video is not in autoplay list
        if (this.thumbVideosAutoplay.has(videoElement)) {
          this.log('Blocking external pause for thumb video', videoElement);
          return;
        }

        // Otherwise call original method
        this.originalPauseMethods.get(nativeVideo).call(nativeVideo);
      };
    }
  }

  log(...args) {
    if (this.debugMode) {
      console.log('[SwiperSlider]', ...args);
    }
  }

  logOnce(key, ...args) {
    // Log message only once for each key
    if (!this._loggedMessages) {
      this._loggedMessages = new Set();
    }

    if (!this._loggedMessages.has(key)) {
      this.log(...args);
      this._loggedMessages.add(key);
    }
  }

  initVideoControls() {
    // Initialize video controls only for required sliders
    if (!this.isPDPGallery() && !this.isMainPDPGalleryThumb()) {
      return;
    }

    this.log('Initializing video controls');

    // Clean up previous controls if any
    this.cleanupVideoControls();

    // Initialize video controls for all slides
    const allSlides = this.querySelectorAll('swiper-slide');

    allSlides.forEach((slide) => {
      this.setupVideoControlsForSlide(slide);
    });

    this.videoControlsInitialized = true;
  }

  cleanupVideoControls() {
    const allSlides = this.querySelectorAll('swiper-slide');

    allSlides.forEach((slide) => {
      // Remove event handlers
      const playBtn = slide.querySelector('.product-gallery__video-play-icon');
      const pauseBtn = slide.querySelector('.product-gallery__video-pause-icon');

      if (playBtn && playBtn._videoHandler) {
        playBtn.removeEventListener('click', playBtn._videoHandler);
        delete playBtn._videoHandler;
      }

      if (pauseBtn && pauseBtn._videoHandler) {
        pauseBtn.removeEventListener('click', pauseBtn._videoHandler);
        delete pauseBtn._videoHandler;
      }

      // Remove initialization attribute
      slide.removeAttribute('data-video-controls-initialized');
    });

    this.log('Cleaned up video controls');
  }

  setupVideoControlsForSlide(slide) {
    const videoActions = slide.querySelector('.product-gallery__video-actions');
    if (!videoActions) return;

    const playBtn = videoActions.querySelector('.product-gallery__video-play-icon');
    const pauseBtn = videoActions.querySelector('.product-gallery__video-pause-icon');
    const videoElement = slide.querySelector('video-media');

    if (!playBtn || !pauseBtn || !videoElement) return;

    // Check if already initialized for this slide
    if (slide.hasAttribute('data-video-controls-initialized')) {
      this.log('Video controls already initialized for slide, skipping');
      return;
    }

    // Remove old listeners if any
    if (playBtn._videoHandler) {
      playBtn.removeEventListener('click', playBtn._videoHandler);
    }
    if (pauseBtn._videoHandler) {
      pauseBtn.removeEventListener('click', pauseBtn._videoHandler);
    }

    // Create unique handlers for this slide
    const playHandler = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.log('Play button clicked for slide');
      this.handleVideoPlay(videoElement, playBtn, pauseBtn);
    };

    const pauseHandler = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.log('Pause button clicked for slide');
      this.handleVideoPause(videoElement, playBtn, pauseBtn);
    };

    // Store reference to handlers for possible removal
    playBtn._videoHandler = playHandler;
    pauseBtn._videoHandler = pauseHandler;

    // Add listeners
    playBtn.addEventListener('click', playHandler);
    pauseBtn.addEventListener('click', pauseHandler);

    // Set initial button state
    this.updateVideoButtonsState(videoElement, playBtn, pauseBtn);

    // Add listeners for automatic video control
    this.setupAutoVideoControl(slide, videoElement);

    // Mark as initialized
    slide.setAttribute('data-video-controls-initialized', 'true');
    this.log('Video controls initialized for slide');
  }

  handleVideoPlay(videoElement, playBtn, pauseBtn) {
    console.log('Manual play button clicked');

    // If this is thumb gallery, add to autoplay list
    if (this.isMainPDPGalleryThumb()) {
      this.thumbVideosAutoplay.add(videoElement);
    }

    this.playVideo(videoElement);
    this.updateVideoButtonsState(videoElement, playBtn, pauseBtn);
  }

  handleVideoPause(videoElement, playBtn, pauseBtn) {
    console.log('Manual pause button clicked');

    // If this is thumb gallery, remove from autoplay list
    if (this.isMainPDPGalleryThumb()) {
      this.thumbVideosAutoplay.delete(videoElement);
    }

    this.pauseVideo(videoElement);
    this.updateVideoButtonsState(videoElement, playBtn, pauseBtn);
  }

  setupAutoVideoControl(slide, videoElement) {
    if (!videoElement) return;

    // Add listeners for native video
    const nativeVideo = videoElement.querySelector('video');
    if (nativeVideo) {
      nativeVideo.addEventListener('play', () => {
        this.handleVideoStarted(videoElement);
      });

      nativeVideo.addEventListener('pause', () => {
        this.handleVideoStopped(videoElement);
      });

      nativeVideo.addEventListener('ended', () => {
        this.handleVideoStopped(videoElement);
      });
    }

    // For external videos (YouTube, Vimeo) use MutationObserver
    // to track class changes
    if (videoElement.hasAttribute('host')) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isPlaying = this.isVideoPlaying(videoElement);
            if (isPlaying) {
              this.handleVideoStarted(videoElement);
            } else {
              this.handleVideoStopped(videoElement);
            }
          }
        });
      });

      observer.observe(videoElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }
  }

  handleVideoStarted(videoElement) {
    this.log('Video started playing:', videoElement);

    // Hide slider navigation buttons only if video is in active slide
    const slide = videoElement.closest('swiper-slide');
    const isActive = slide && this.isSlideActive(slide);
    this.log('Video slide is active:', isActive);

    if (isActive) {
      this.hideSliderNavigation();
    }

    // Update video buttons
    if (slide) {
      this.updateVideoButtonsForSlide(slide, videoElement);
    }
  }

  handleVideoStopped(videoElement) {
    this.log('Video stopped playing:', videoElement);

    // Show slider navigation buttons only if there are no other active videos
    const hasActive = this.hasActiveVideos();
    this.log('Has other active videos:', hasActive);

    if (!hasActive) {
      this.showSliderNavigation();
    }

    // Update video buttons
    const slide = videoElement.closest('swiper-slide');
    if (slide) {
      this.updateVideoButtonsForSlide(slide, videoElement);
    }
  }

  hasActiveVideos() {
    if (!this.slider) return false;

    const allVideoElements = this.slider.querySelectorAll('video-media');

    for (const videoElement of allVideoElements) {
      const slide = videoElement.closest('swiper-slide');
      if (this.isSlideActive(slide) && this.isVideoPlaying(videoElement)) {
        return true;
      }
    }

    return false;
  }

  isSlideActive(slide) {
    if (!slide) return false;

    // For PDP gallery check if this is active slide
    if (this.isPDPGallery()) {
      return slide.classList.contains('swiper-slide-active');
    }

    // For Thumb gallery all visible slides are considered "active"
    if (this.isMainPDPGalleryThumb()) {
      const visibleSlides = this.getVisibleSlides();
      return visibleSlides.includes(slide);
    }

    return false;
  }

  hideSliderNavigation() {
    if (!this.slider) return;

    this.log('Hiding slider navigation');

    // Find navigation buttons in different places
    const nextBtns = [
      this.slider.querySelector('.swiper-button-next'),
      this.querySelector('.swiper-button-next'),
      this.buttonNext,
    ].filter(Boolean);

    const prevBtns = [
      this.slider.querySelector('.swiper-button-prev'),
      this.querySelector('.swiper-button-prev'),
      this.buttonPrev,
    ].filter(Boolean);

    [...nextBtns, ...prevBtns].forEach((btn) => {
      if (btn) {
        btn.style.opacity = '0';
        btn.style.pointerEvents = 'none';
        btn.style.transition = 'opacity 0.3s ease';
        this.log('Hidden navigation button:', btn);
      }
    });
  }

  showSliderNavigation() {
    if (!this.slider) return;

    this.log('Showing slider navigation');

    // Find navigation buttons in different places
    const nextBtns = [
      this.slider.querySelector('.swiper-button-next'),
      this.querySelector('.swiper-button-next'),
      this.buttonNext,
    ].filter(Boolean);

    const prevBtns = [
      this.slider.querySelector('.swiper-button-prev'),
      this.querySelector('.swiper-button-prev'),
      this.buttonPrev,
    ].filter(Boolean);

    [...nextBtns, ...prevBtns].forEach((btn) => {
      if (btn) {
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
        btn.style.transition = '';
        this.log('Shown navigation button:', btn);
      }
    });
  }

  updateVideoButtonsState(videoElement, playBtn, pauseBtn) {
    if (!playBtn || !pauseBtn) return;

    setTimeout(() => {
      const isPlaying = this.isVideoPlaying(videoElement);
      if (isPlaying) {
        playBtn.style.display = 'none';
        pauseBtn.style.display = 'grid';
      } else {
        playBtn.style.display = 'grid';
        pauseBtn.style.display = 'none';
      }
    }, 500);
  }

  isVideoPlaying(videoElement) {
    if (!videoElement) return false;

    const nativeVideo = videoElement.querySelector('video');
    if (nativeVideo) {
      const isPlaying = !nativeVideo.paused && !nativeVideo.ended && nativeVideo.readyState > 2;

      // Log only state changes, not every check
      if (!videoElement._lastPlayingState || videoElement._lastPlayingState !== isPlaying) {
        this.log('Native video state changed:', isPlaying, {
          paused: nativeVideo.paused,
          ended: nativeVideo.ended,
          readyState: nativeVideo.readyState,
        });
        videoElement._lastPlayingState = isPlaying;
      }
      return isPlaying;
    }

    // For external videos (YouTube, Vimeo) it's more complex to determine state
    // Check if video has host attribute and iframe
    const host = videoElement.getAttribute('host');
    const iframe = videoElement.querySelector('iframe');

    if ((host === 'youtube' || host === 'vimeo') && iframe) {
      // For external videos check state classes
      const isPlaying =
        videoElement.classList.contains('video-playing') && !videoElement.classList.contains('video-paused');

      // Log only state changes
      if (!videoElement._lastPlayingState || videoElement._lastPlayingState !== isPlaying) {
        this.log('External video state changed:', isPlaying, {
          host: host,
          hasPlaying: videoElement.classList.contains('video-playing'),
          hasPaused: videoElement.classList.contains('video-paused'),
        });
        videoElement._lastPlayingState = isPlaying;
      }
      return isPlaying;
    }

    return false;
  }
}

customElements.define('component-slider-swiper', SwiperSlider);
